import { render, staticRenderFns } from "./ChangePasswordTab.vue?vue&type=template&id=636def92&scoped=true"
import script from "./ChangePasswordTab.vue?vue&type=script&lang=js"
export * from "./ChangePasswordTab.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordTab.vue?vue&type=style&index=0&id=636def92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636def92",
  null
  
)

export default component.exports